/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ToOrderRouteImport } from './routes/to-order'
import { Route as InventoryIndexRouteImport } from './routes/inventory/index'
import { Route as InventoryPartIdRouteImport } from './routes/inventory/$partId'
import { Route as OrdersIndexRouteImport } from './routes/orders/index'
import { Route as OrdersOrderIdRouteImport } from './routes/orders/$orderId'
import { Route as TemplatesIndexRouteImport } from './routes/templates/index'
import { Route as TemplatesTemplateIdRouteImport } from './routes/templates/$templateId'
import { Route as VehiclesIndexRouteImport } from './routes/vehicles/index'
import { Route as VehiclesVehicleIdRouteImport } from './routes/vehicles/$vehicleId'
import { Route as WorkOrdersIndexRouteImport } from './routes/work-orders/index'
import { Route as WorkOrdersWorkOrderIdRouteImport } from './routes/work-orders/$workOrderId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ToOrderRoute = ToOrderRouteImport.update({
  id: '/to-order',
  path: '/to-order',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryIndexRoute = InventoryIndexRouteImport.update({
  id: '/inventory/',
  path: '/inventory/',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryPartIdRoute = InventoryPartIdRouteImport.update({
  id: '/inventory/$partId',
  path: '/inventory/$partId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersOrderIdRoute = OrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesTemplateIdRoute = TemplatesTemplateIdRouteImport.update({
  id: '/templates/$templateId',
  path: '/templates/$templateId',
  getParentRoute: () => rootRouteImport,
} as any)
const VehiclesIndexRoute = VehiclesIndexRouteImport.update({
  id: '/vehicles/',
  path: '/vehicles/',
  getParentRoute: () => rootRouteImport,
} as any)
const VehiclesVehicleIdRoute = VehiclesVehicleIdRouteImport.update({
  id: '/vehicles/$vehicleId',
  path: '/vehicles/$vehicleId',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkOrdersIndexRoute = WorkOrdersIndexRouteImport.update({
  id: '/work-orders/',
  path: '/work-orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkOrdersWorkOrderIdRoute = WorkOrdersWorkOrderIdRouteImport.update({
  id: '/work-orders/$workOrderId',
  path: '/work-orders/$workOrderId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRoute
  '/to-order': typeof ToOrderRoute
  '/inventory/$partId': typeof InventoryPartIdRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/templates/$templateId': typeof TemplatesTemplateIdRoute
  '/vehicles/$vehicleId': typeof VehiclesVehicleIdRoute
  '/work-orders/$workOrderId': typeof WorkOrdersWorkOrderIdRoute
  '/inventory/': typeof InventoryIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/vehicles/': typeof VehiclesIndexRoute
  '/work-orders/': typeof WorkOrdersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRoute
  '/to-order': typeof ToOrderRoute
  '/inventory/$partId': typeof InventoryPartIdRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/templates/$templateId': typeof TemplatesTemplateIdRoute
  '/vehicles/$vehicleId': typeof VehiclesVehicleIdRoute
  '/work-orders/$workOrderId': typeof WorkOrdersWorkOrderIdRoute
  '/inventory': typeof InventoryIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/vehicles': typeof VehiclesIndexRoute
  '/work-orders': typeof WorkOrdersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/settings': typeof SettingsRoute
  '/to-order': typeof ToOrderRoute
  '/inventory/$partId': typeof InventoryPartIdRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/templates/$templateId': typeof TemplatesTemplateIdRoute
  '/vehicles/$vehicleId': typeof VehiclesVehicleIdRoute
  '/work-orders/$workOrderId': typeof WorkOrdersWorkOrderIdRoute
  '/inventory/': typeof InventoryIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/vehicles/': typeof VehiclesIndexRoute
  '/work-orders/': typeof WorkOrdersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/to-order'
    | '/inventory/$partId'
    | '/orders/$orderId'
    | '/templates/$templateId'
    | '/vehicles/$vehicleId'
    | '/work-orders/$workOrderId'
    | '/inventory/'
    | '/orders/'
    | '/templates/'
    | '/vehicles/'
    | '/work-orders/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/settings'
    | '/to-order'
    | '/inventory/$partId'
    | '/orders/$orderId'
    | '/templates/$templateId'
    | '/vehicles/$vehicleId'
    | '/work-orders/$workOrderId'
    | '/inventory'
    | '/orders'
    | '/templates'
    | '/vehicles'
    | '/work-orders'
  id:
    | '__root__'
    | '/'
    | '/settings'
    | '/to-order'
    | '/inventory/$partId'
    | '/orders/$orderId'
    | '/templates/$templateId'
    | '/vehicles/$vehicleId'
    | '/work-orders/$workOrderId'
    | '/inventory/'
    | '/orders/'
    | '/templates/'
    | '/vehicles/'
    | '/work-orders/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SettingsRoute: typeof SettingsRoute
  ToOrderRoute: typeof ToOrderRoute
  InventoryPartIdRoute: typeof InventoryPartIdRoute
  OrdersOrderIdRoute: typeof OrdersOrderIdRoute
  TemplatesTemplateIdRoute: typeof TemplatesTemplateIdRoute
  VehiclesVehicleIdRoute: typeof VehiclesVehicleIdRoute
  WorkOrdersWorkOrderIdRoute: typeof WorkOrdersWorkOrderIdRoute
  InventoryIndexRoute: typeof InventoryIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  TemplatesIndexRoute: typeof TemplatesIndexRoute
  VehiclesIndexRoute: typeof VehiclesIndexRoute
  WorkOrdersIndexRoute: typeof WorkOrdersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/to-order': {
      id: '/to-order'
      path: '/to-order'
      fullPath: '/to-order'
      preLoaderRoute: typeof ToOrderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/': {
      id: '/inventory/'
      path: '/inventory'
      fullPath: '/inventory/'
      preLoaderRoute: typeof InventoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/$partId': {
      id: '/inventory/$partId'
      path: '/inventory/$partId'
      fullPath: '/inventory/$partId'
      preLoaderRoute: typeof InventoryPartIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$orderId': {
      id: '/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof OrdersOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/': {
      id: '/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof TemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/$templateId': {
      id: '/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/templates/$templateId'
      preLoaderRoute: typeof TemplatesTemplateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vehicles/': {
      id: '/vehicles/'
      path: '/vehicles'
      fullPath: '/vehicles/'
      preLoaderRoute: typeof VehiclesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vehicles/$vehicleId': {
      id: '/vehicles/$vehicleId'
      path: '/vehicles/$vehicleId'
      fullPath: '/vehicles/$vehicleId'
      preLoaderRoute: typeof VehiclesVehicleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders/': {
      id: '/work-orders/'
      path: '/work-orders'
      fullPath: '/work-orders/'
      preLoaderRoute: typeof WorkOrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders/$workOrderId': {
      id: '/work-orders/$workOrderId'
      path: '/work-orders/$workOrderId'
      fullPath: '/work-orders/$workOrderId'
      preLoaderRoute: typeof WorkOrdersWorkOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SettingsRoute: SettingsRoute,
  ToOrderRoute: ToOrderRoute,
  InventoryPartIdRoute: InventoryPartIdRoute,
  OrdersOrderIdRoute: OrdersOrderIdRoute,
  TemplatesTemplateIdRoute: TemplatesTemplateIdRoute,
  VehiclesVehicleIdRoute: VehiclesVehicleIdRoute,
  WorkOrdersWorkOrderIdRoute: WorkOrdersWorkOrderIdRoute,
  InventoryIndexRoute: InventoryIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  TemplatesIndexRoute: TemplatesIndexRoute,
  VehiclesIndexRoute: VehiclesIndexRoute,
  WorkOrdersIndexRoute: WorkOrdersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
